import {Fade, Slide, TransitionComponentType} from '@aboutyou/transitions';
import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../../../constants/colors';
import {AboutYouHeartIcon, AboutYouKnob} from './AboutYouIcon';

// This is defined based on a wide letter (O) and narrowest viewport available in chrome devtools (Iphone SE)
// it keeps meaningful space around the logo and prevents horizontal scroll
const DEFAULT_MAX_LENGTH = 18;

export const AboutNameTextLogo: React.FC<{
  firstName?: string;
  maxLength?: number;
  showHeartIcon?: boolean;
  FirstNameAnimationComponent?: TransitionComponentType;
}> = React.memo(function AboutNameTextLogo({
  firstName,
  maxLength = DEFAULT_MAX_LENGTH,
  showHeartIcon,
  FirstNameAnimationComponent = Slide,
}) {
  const showFirstName = Boolean(firstName);

  const LogoIcon = showHeartIcon
    ? StyledAboutYouHeartWhite
    : StyledAboutYouKnob;

  return (
    <Wrapper>
      <AboutText data-testid="aboutLogo">ABOUT</AboutText>
      <UserNameWrapper data-testid="userNameWrapper" data-dd-privacy="mask">
        <Fade mounted={!firstName} duration={{mount: 0, unmount: 500}}>
          <YouText data-testid="you">
            YOU
            <LogoIcon />
          </YouText>
        </Fade>
        <FirstNameAnimationComponent
          mounted={showFirstName}
          duration={1000}
          direction="left"
          transformLength={25}
        >
          <StyledLogoText data-testid="userName" data-dd-privacy="mask">
            {firstName?.slice(0, maxLength)}
            <LogoIcon />
          </StyledLogoText>
        </FirstNameAnimationComponent>
      </UserNameWrapper>
    </Wrapper>
  );
});

const Wrapper = styled.div`
  display: flex;
  position: relative;
  min-width: 160px;
  max-height: inherit;

  [dir='rtl'] & {
    direction: initial;
  }
`;

export const LogoText = styled.span`
  display: flex;
  font-family: 'Open Sans Condensed Bold', sans-serif;
  text-transform: uppercase;
  font-size: 30px;
  font-weight: 700;
  padding: 0 4px;
  color: ${COLORS.White};
  background-color: ${COLORS.Black};
  white-space: nowrap;
  direction: initial;
  display: inline;
  max-height: inherit;
`;

const AboutText = styled(LogoText)`
  position: relative;
  margin-right: 2px;

  [dir='rtl'] & {
    margin-left: 2px;
    margin-right: unset;
  }
`;

const YouText = styled(LogoText)`
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.58s ease-out;
  padding-right: 18px;

  [dir='rtl'] & {
    right: 0;
    left: unset;
    padding-right: unset;
    padding-left: 18px;
  }
`;

export const StyledLogoText = styled(LogoText)`
  padding-right: 18px;
  max-height: inherit;
  display: flex;
  left: 0;
  margin-right: 0;
  padding: 0px 18px 0px 4px;

  [dir='rtl'] & {
    right: 0;
    margin-left: 0;
    padding: 0px 4px 0px 18px;
  }
`;

const UserNameWrapper = styled.span`
  position: relative;
  direction: initial;
  max-height: inherit;
`;

const StyledAboutYouKnob = styled(AboutYouKnob)`
  position: absolute;
  top: 6px;
  right: 5px;

  [dir='rtl'] & {
    left: 5px;
    right: unset;
  }
`;

const StyledAboutYouHeartWhite = styled(AboutYouHeartIcon)`
  position: absolute;
  top: 3px;
  right: 2px;

  [dir='rtl'] & {
    left: 2px;
    right: unset;
  }
`;
